import { useMemo } from 'react';
import compact from 'lodash/compact';

import useStudentExamRecords from '@/data/hook/student-exam/useStudentExamRecords';
import { isStartedScheduledExam } from '@/utils/student-exam/isStartedScheduledExam';

export type ExamPendency = {
  count: number;
  dueDate?: string;
};

type UseStudentExamPendencyParams = {
  studentId?: number;
  klassId?: number;
};

export default function useStudentExamPendency({
  studentId,
  klassId,
}: UseStudentExamPendencyParams) {
  const { records, isLoading, error } = useStudentExamRecords({
    studentId: studentId ?? 0,
    klassId,
  });

  const examPendency = useMemo<ExamPendency>(() => {
    const startedRecords = records.filter(isStartedScheduledExam);
    const [dueDate] = compact(
      startedRecords.map(({ closesAt }) => closesAt),
    ).sort();

    return { count: startedRecords.length, dueDate };
  }, [records]);

  return {
    examPendency,
    isLoading,
    error,
  };
}
